import { useEffect, useState } from 'react';
import { driverSupabase as supabase } from '@/integrations/supabase/driver-client';

export interface SurgePayload {
  city_id?: string;
  multiplier?: number;
  vehicle_type?: string;
  effective_at?: string;
  reason?: string;
}

/**
 * P2: Surge / fare-config Broadcast listener.
 *
 * Subscribes to `surge-updates` Broadcast channel. Admin emits
 * `{ event: 'surge_change', payload: SurgePayload }`. Returns the latest
 * surge payload so consumers (e.g. GlobalTripOfferOverlay) can refresh
 * their local fare display.
 */
export function useSurgeBroadcast(): SurgePayload | null {
  const [surge, setSurge] = useState<SurgePayload | null>(null);

  useEffect(() => {
    const channel = supabase
      .channel('surge-updates')
      .on('broadcast', { event: 'surge_change' }, ({ payload }) => {
        setSurge(payload as SurgePayload);
      })
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, []);

  return surge;
}
